import { createContext, useContext, useState } from "react";

const HeaderContext = createContext();

export function HeaderProvider({ children }) {
  const [headerKey, setHeaderKey] = useState("");

  return (
    <HeaderContext.Provider value={{ headerKey, setHeaderKey }}>
      {children}
    </HeaderContext.Provider>
  );
}

export function useHeader() {
  return useContext(HeaderContext);
}